import { render, staticRenderFns } from "./BaseNotFoundLite.vue?vue&type=template&id=34376091&scoped=true&"
import script from "./BaseNotFoundLite.vue?vue&type=script&lang=js&"
export * from "./BaseNotFoundLite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34376091",
  null
  
)

export default component.exports